import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import {useAuthInfo} from '@oc/shell-core'
import * as React from 'react'
import {keyBoardPressActions} from '@oc/utils'

export interface LegalTextApprovalProps {
    userName: string
    legalText: string
    legalTextHeader: string
    approval: string
    agree: string
    disagree: string
}

export function LegalTextApproval(props: LegalTextApprovalProps) {
    const {userName, legalText, legalTextHeader, approval, agree, disagree} = props
    const {signOut} = useAuthInfo()

    const [open, setOpen] = React.useState(true)
    const keyLT = `${userName}_legalTextApproval`

    const handleAgree = React.useCallback(() => {
        localStorage.setItem(keyLT, approval)
        setOpen(false)
    }, [approval, keyLT])

    if (localStorage.getItem(keyLT) !== approval) {
        return (
            <Dialog
                onKeyUp={event => {
                    keyBoardPressActions(
                        event,
                        signOut,
                        handleAgree,
                        undefined,
                        undefined,
                        localStorage.getItem(keyLT) !== approval
                    )
                }}
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{legalTextHeader}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{legalText}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={signOut} color="primary">
                        {disagree}
                    </Button>
                    <Button onClick={handleAgree}>{agree}</Button>
                </DialogActions>
            </Dialog>
        )
    } else {
        return null
    }
}
